import * as React from "react";
import { Form, useFormApi } from "informedv4";
import { Dropdown } from "../../../../forms/informedv4/DropdownV4";

interface ToggleSuppressSessionProps {
    originalSuppressState: string;
    correctedSuppressState: string;
    onNext: (correctedSuppressState: string) => void;
    onChange: (correctedSuppressState: string) => void;
}

interface ToggleSuppressSessionForm {
    correctedSuppressedState: string;
}

const options = [{
    Id: "true",
    Name: "Suppressed"
}, {
        Id: "false",
        Name: "Not Suppressed"
    }];

export const ToggleSuppressSession = ({ originalSuppressState, correctedSuppressState, onNext, onChange }: ToggleSuppressSessionProps): JSX.Element => {
    const formApi = useFormApi();

    const onSubmit = () => {
        formApi.validate();

        const state = formApi.getFormState();

        if (state.invalid)
            return;

        onNext(state.values.correctedSuppressedState as string);
    }

    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <p className="text-muted">
                            Toggle Session Suppress State
                    </p>
                        <div className="form-group">
                            <label>Current Session Suppress State</label>&nbsp;
                        {
                                <Dropdown
                                    name="originalSuppressedState"
                                    disabled={true}
                                    id={`select-issuppressed-prevalue`}
                                    field="originalSuppressedState"
                                    className="form-control"
                                >
                                    {options.map(s => (
                                        <option key={`IsSuppressedPre${s.Id}`} value={s.Id}>
                                            {s.Name}
                                        </option>
                                    ))}
                                </Dropdown>
                            }
                        </div>
                        <div className="form-group">
                            <label>Change Session Suppress State</label>&nbsp;
                            {
                                <Dropdown
                                    name="correctedSuppressedState"
                                    disabled={false}
                                    id={`select-issuppressed-correctedvalue`}
                                    onChange={e => { onChange((e as any).target.value) }}
                                    field="correctedSuppressedState"
                                    className="form-control"
                                >
                                    {options.map(s => (
                                        <option key={`IsSuppressedPre${s.Id}`} value={s.Id}>
                                            {s.Name}
                                        </option>
                                    ))}
                                </Dropdown>
                            }
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button disabled={!correctedSuppressState || correctedSuppressState == originalSuppressState} className="btn btn-primary" type="submit" onClick={() => onSubmit()}>Next</button>
            </div>
        </>);
};
